import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accept-policy',
  templateUrl: './accept-policy.component.html',
  styleUrls: ['./accept-policy.component.scss'],
})
export class AcceptPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
